import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  state: null,
  options: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
    autoHideDuration: 2000,
    message: 'Hi',
    variant: null,
  },
};
const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    showMessage: (state, action) => {
      state.state = true;
      state.options = {
        ...initialState.options,
        ...action.payload,
      };
    },
    hideMessage: (state, action) => {
      state.state = null;
    },
  },
});

//variant can be null, 'success', 'error', 'warning' or 'info'
export const { hideMessage, showMessage } = messageSlice.actions;

export const selectABSMessageState = ({ abs }) => abs.message.state;

export const selectABSMessageOptions = ({ abs }) => abs.message.options;

export default messageSlice.reducer;
